import React, { useState, useEffect } from "react";
import { ConfigProvider, Table } from "antd";

export default function TableDevice({ columns, dataMeeting }) {
  useEffect(() => {}, []);
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            fontFamily: "Kanit",
            headerColor: "rgba(0, 0, 0, 0.88)",
            fontSize: "12px",
            fontWeight: "400",
            lineHeight: "22px",
            color: "#4F4F4F",
            footerBg: "#f8f9fa",
          },
        },
      }}
    >
      <Table
        className="pagination-cardMeeting"
        columns={columns}
        dataSource={dataMeeting}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        footer={() => (
          <div
            style={{
              color: "#FFC700",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            <span
              style={{
                color: "#A4A4A4",
                fontSize: "14px",
                fontWeight: "300",
              }}
            >
              รวม ​:{" "}
            </span>
            {dataMeeting.length} รายการ
          </div>
        )}
        scroll={{
          x: "auto",
        }}
      />
    </ConfigProvider>
  );
}
